import React, { useState, useEffect, useCallback } from "react"
import axiosConfig from "../Service/axiosConfig"
import { useScrollContext } from "../Utils/ScrollContext";
import { ExploreGrid } from "./exploregrid";
import { NavLink, useNavigate } from "react-router-dom";
const ProfileFollows = ({ ProfileData, can_edit_profile }) => {
    const [FollowersData, SetFollowersData] = useState([]);
    const [FollowingData, SetFollowingData] = useState([]);
    const [nextUrl, setNextUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const { registerLoadMore } = useScrollContext();
    const navigate = useNavigate();
    const GetData = async (tab = activeTab) => {
        setLoading(true);
        try {
            const params =
                tab === 0
                    ? `profile=${ProfileData.id}`
                    : `user=${ProfileData.user.id}`;

            const response = await axiosConfig.get(
                `/accounts/follows/?${params}&page_size=20`
            );

            if (tab === 0) {
                SetFollowersData(response.data.results);
            } else {
                SetFollowingData(response.data.results);
            }

            setNextUrl(response.data.next);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    const handleInfiniteScroll = useCallback(async () => {
        if (loadingMore || !nextUrl) return;
        setLoadingMore(true);
        try {
            const resp = await axiosConfig.get(nextUrl);

            if (activeTab === 0) {
                SetFollowersData((prev) => [...prev, ...resp.data.results]);
            } else {
                SetFollowingData((prev) => [...prev, ...resp.data.results]);
            }
            setNextUrl(resp.data.next);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingMore(false);
        }
    }, [loadingMore, nextUrl, activeTab]);
    useEffect(() => {
        if (ProfileData?.id) {
            GetData(activeTab);
        }
    }, [activeTab, ProfileData?.id]);
    useEffect(() => {
        registerLoadMore(handleInfiniteScroll);
        return () => registerLoadMore(null);
    }, [handleInfiniteScroll, registerLoadMore]);
    const handleTabClick = (index) => {
        setActiveTab(index);
        setNextUrl(null);
    };
    const SendMessage = (hcc_id) => {
        navigate(`/messages/${hcc_id}`);
    };
    const displayData = activeTab === 0 ? FollowersData : FollowingData;
    const getUserData = (follow) => {
        return activeTab === 0 ? follow.user : follow.profile;
    };
    return (
        <>
            <div className="profile-tablinks">
                <ul className="nav custom-nav-tabs justify-content-center">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 0 ? "active" : ""}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Followers
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 1 ? "active" : ""}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Following
                        </button>
                    </li>
                </ul>
            </div>
            {loading ? (
                <div className="loader-container">
                    <img
                        src={require("./images/loader.gif")}
                        alt="Loading..."
                    />
                </div>
            ) : (
                <div className="container">
                    <div
                        className="search-screen-container search-page"
                        style={{ overflow: "hidden" }}
                    >
                        <div
                            className="content-area"
                            style={{ position: "relative" }}
                        >
                            {displayData.length === 0 ? (
                                <p style={{ textAlign: "center" }}>
                                    No data found
                                </p>
                            ) : (
                                displayData.map((follow, index) => {
                                    const userData = getUserData(follow);

                                    return (
                                        <div
                                            className="like-content"
                                            key={index}
                                        >
                                            <div
                                                className="d-flex"
                                                style={{ gap: "10px" }}
                                            >
                                                <NavLink
                                                    target="_blank"
                                                    to={`/profile/${userData.hcc_id}`}
                                                >
                                                    <img
                                                        src={
                                                            userData.profile_pic ||
                                                            require("./images/male.jpg")
                                                        }
                                                        alt={`${userData.first_name} ${userData.last_name}`}
                                                        className="profile-like"
                                                    />
                                                </NavLink>

                                                <div>
                                                    <NavLink
                                                        target="_blank"
                                                        to={`/profile/${userData.hcc_id}`}
                                                        className="like-name"
                                                    >
                                                        <span>
                                                            {userData.first_name}{" "}
                                                            {userData.last_name}
                                                        </span>
                                                    </NavLink>
                                                </div>
                                            </div>

                                            <div
                                                className="message-btn"
                                                onClick={() =>
                                                    SendMessage(
                                                        userData.hcc_id
                                                    )
                                                }
                                            >
                                                Message
                                            </div>
                                        </div>
                                    );
                                })
                            )}
                            {loadingMore && (
                                <div style={{ textAlign: "center", padding: 10 }}>
                                    Loading more...
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export { ProfileFollows };